import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  changeNumerpAposta,
  changeNumerpApostaClear,
  addNumeroAposta,
  changeNumeroApostaClearAll,
} from "../../reducers/modalidade/modalidadeInputAction";
import {
  formataNumeroApostaSeparador,
  geraSurpresinha,
} from "../utils/apostaUtils";
import { validaNumeroDigitado } from "../utils/modalidadeUtils";
import { getDeviceType, getOrientation } from "../../modules/helpers";
import NumberGridBicho from "../../rifa/components/numberGridBicho";
import { NumberBichoGroup } from "../../rifa/components/layout/numberBichoGroup";
import { X } from "phosphor-react";

import animals from "../../utils/numberBichoData";
import LoteriaButton from "../loteriaButton";
import LoteriaKeyPadButton from "../loteriaKeyPadButton";

import "../../concurso/concurso.css";
import "./modalidade.css";
import { toastr } from "react-redux-toastr";

import {
  AnalyticsSetGameStep,
  AnalyticsSetSpecifics
} from "../../reducers/analytics/analyticsActions";

const BTN_ADICIONAR = "BTN_ADICIONAR";
const BTN_SURPRESA = "BTN_SURPRESA";
const BTN_LIMPAR = "BTN_LIMPAR";

class ModalidadeInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      arrNumbers: [],
    };

    this.addNumber = this.addNumber.bind(this);
    this.removeNumber = this.removeNumber.bind(this);
    this.buttonClick = this.buttonClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const inputElement = document.getElementById("numeroInput");
    inputElement.addEventListener("keydown", (e) => {
      if (e.which === 13 && !e.shiftKey) {
        e.preventDefault();

        if (this.props.numeroAposta) {
          this.addNumber(this.props.numeroAposta);
        }
      }
    });
  }

  addNumber(numVal) {
    var arrNum = this.props.arrNumerosAposta;

    const maxAmount =
      this.props.maxAmount == null ? Infinity : this.props.maxAmount;

    if (!validaNumeroDigitado(this.props.modalidade.objTipoJogo, numVal)) {
      this.props.toggleErrorModal &&
        this.props.toggleErrorModal(
          "Aposta Inválida",
          "Número inválido para este tipo de jogo."
        );
    } else if ((arrNum || []).length >= maxAmount) {
      this.props.toggleErrorModal &&
        this.props.toggleErrorModal(
          "Aposta Inválida",
          "Limite máximo de palpites excedido."
        );
    } else {
      //Verificar se já existe o número no array, caso sim, não inserir o mesmo num novamente.
      if (!arrNum.includes(numVal)) {
        this.props.AnalyticsSetGameStep('Chose Number');
        arrNum.push(numVal);
        this.props.addNumeroAposta(arrNum);

        this.setState({ arrNumbers: arrNum });
      }
    }
    this.props.changeNumerpApostaClear();
  }

  surpresaButtonClick() {
    this.props.AnalyticsSetSpecifics('Chose Lucky Number');

    const tipoJogo = this.props.modalidade.objTipoJogo;
    var surpresa = geraSurpresinha(tipoJogo);
    this.props.changeNumerpAposta(surpresa);
    this.addNumber(surpresa);
  }

  removeNumber(numVal) {
    var arrNum = this.props.arrNumerosAposta;
    var index = arrNum.indexOf(numVal);
    if (index > -1) {
      arrNum.splice(index, 1);
      this.props.addNumeroAposta(arrNum);
      this.setState({ arrNumbers: arrNum });
    }
  }

  buttonClick(e) {
    switch (e.target.id) {
      case BTN_SURPRESA:
        //return this.props.handleSurpresaClick()
        return this.surpresaButtonClick();
      case BTN_LIMPAR:
        this.props.changeNumerpApostaClear();
        return this.props.handleLimparClick();
      default:
        return;
    }
  }

  handleChange(evt) {
    const tipoJogo = this.props.modalidade.objTipoJogo;

    const maxLength = tipoJogo.tnyTamanhoMax;
    let strNumeroCorrente = evt.target.value
      .split((tipoJogo.chrSeparador || "").trim())
      .join("");

    var strNumero = formataNumeroApostaSeparador(
      evt.target.value,
      tipoJogo
    );
    this.props.changeNumerpAposta(strNumero);

    //Se atingiu o tamanho max, add automaticamente
    if (strNumeroCorrente.length >= maxLength) {
      this.addNumber(strNumero);
    }
  }
  handleClick(evt) {
    const tipoJogo = this.props.modalidade.objTipoJogo;

    const maxLength = tipoJogo.tnyTamanhoMax;
    let strNumeroCorrente = this.props.numeroAposta
      .split((tipoJogo.chrSeparador || "").trim())
      .join("");

    if (strNumeroCorrente.length < maxLength) {
      strNumeroCorrente += evt.target.value;

      var strNumero = formataNumeroApostaSeparador(
        this.props.numeroAposta + evt.target.value,
        tipoJogo
      );
      this.props.changeNumerpAposta(strNumero);

      //Se atingiu o tamanho max, add automaticamente
      if (strNumeroCorrente.length >= maxLength) {
        this.addNumber(strNumero);
      }
    }
  }

  renderRemoveButton(numeroAp) {
    return (
      <div
        className="removeNumBtn"
        onClick={() => numeroAp && this.removeNumber(numeroAp)}
      >
        <i className="glyphicon glyphicon-remove-sign"></i>
      </div>
    );
  }

  renderNumerosAposta() {
    var arrNum = this.props.arrNumerosAposta;
    const tipoJogo = this.props.modalidade.objTipoJogo;
    const isGroup = tipoJogo.tnyNumeroMax === 25 && tipoJogo.tnyNumeroMin === 1;
    const isCombined =
      !!tipoJogo.tnyTamanhoMax &&
      !!tipoJogo.tnyTamanhoMin &&
      tipoJogo.tnyTamanhoMax != tipoJogo.tnyTamanhoMin;

    return isGroup ? (
      <div className="groups-flex-wrapper">
        {isCombined ? (
          <NumberBichoGroup
            isCombined={isCombined}
            hideCorrespondantNumbers
            withCloseButton
            closeElement={this.renderRemoveButton()}
            onCloseClick={this.removeNumber}
            numbers={arrNum}
            separatorChar={tipoJogo.chrSeparador}
            separatorElement={<X weight="bold" color="var(--primary)" />}
          />
        ) : (
          <NumberBichoGroup
            hideCorrespondantNumbers
            withCloseButton
            closeElement={this.renderRemoveButton()}
            onCloseClick={this.removeNumber}
            numbers={arrNum}
            separatorChar={tipoJogo.chrSeparador}
            separatorElement={<X weight="bold" color="var(--primary)" />}
          />
        )}
      </div>
    ) : (
      <ul className="ks-numtags">
        {arrNum.map((numeroAp) => (
          <li>
            <label>{numeroAp}</label>
            <div
              className="removeNumBtn"
              onClick={() => this.removeNumber(numeroAp)}
            >
              <i className="glyphicon glyphicon-remove-sign"></i>
            </div>
          </li>
        ))}
      </ul>
    );
  }

  renderNumericPad() {
    return (
      <div className="col-12">
        <div className="keyPadLine">
          <LoteriaKeyPadButton
            className={"btn btn-success default-button numKeyPad numKeyPadLeft"}
            value="0"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success default-button numKeyPad numKeyPadCenter"
            }
            value="1"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success default-button numKeyPad numKeyPadCenter"
            }
            value="2"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success default-button numKeyPad numKeyPadCenter"
            }
            value="3"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success default-button numKeyPad numKeyPadCenter"
            }
            value="4"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success default-button numKeyPad numKeyPadCenter"
            }
            value="5"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success default-button numKeyPad numKeyPadCenter"
            }
            value="6"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success default-button numKeyPad numKeyPadCenter"
            }
            value="7"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success default-button numKeyPad numKeyPadCenter"
            }
            value="8"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success default-button numKeyPad numKeyPadCenter"
            }
            value="9"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
        </div>
        <div className="keySurpresa" style={{ marginBottom: "20px" }}>
          <button
            className={"btn bg-navy submit-button btn-surpresinha"}
            onClick={this.buttonClick}
            id={BTN_SURPRESA}
          >
            Surpresinha
          </button>
          <button
            className={"btn btn-danger"}
            style={{ height: "45px", marginRight: "5px" }}
            onClick={this.buttonClick}
            id={BTN_LIMPAR}
          >
            Limpar
          </button>
        </div>
      </div>
    );
  }

  renderAnimalPad() {
    return (
      <div>
        <div className="keypad-animals">
          <NumberGridBicho
            array={animals.map((animal) => animal.number)}
            selections={this.props.arrNumerosAposta}
            disabledNumbers={[]}
            sectionLength={1}
            onSelect={(num) =>
              this.handleClick({
                target: {
                  value: String(num).padStart(2, "0"),
                },
              })
            }
            onDeselect={() => {}}
            onDeselectNumber={(num) =>
              this.removeNumber(String(num).padStart(2, "0"))
            }
          />
        </div>
        <div className="keySurpresa" style={{ marginBottom: "20px" }}>
          <button
            className={"btn bg-navy submit-button btn-surpresinha"}
            onClick={this.buttonClick}
            id={BTN_SURPRESA}
          >
            Surpresinha
          </button>
          <button
            className={"btn btn-danger"}
            style={{ height: "45px", marginRight: "5px" }}
            onClick={this.buttonClick}
            id={BTN_LIMPAR}
          >
            Limpar
          </button>
        </div>
      </div>
    );
  }

  renderNumericPadMobile() {
    return (
      <div className="col-md-12 col-sm-12 col-xs-12 no-padding">
        <div className="keyPadLine">
          <LoteriaKeyPadButton
            className={"btn btn-success submit-button numKeyPad numKeyPadLeft"}
            value="1"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success submit-button numKeyPad numKeyPadCenter"
            }
            value="2"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={"btn btn-success submit-button numKeyPad numKeyPadRight"}
            value="3"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
        </div>
        <div className="keyPadLine">
          <LoteriaKeyPadButton
            className={"btn btn-success submit-button numKeyPad numKeyPadLeft"}
            value="4"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success submit-button numKeyPad numKeyPadCenter"
            }
            value="5"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={"btn btn-success submit-button numKeyPad numKeyPadRight"}
            value="6"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
        </div>
        <div className="keyPadLine">
          <LoteriaKeyPadButton
            className={"btn btn-success submit-button numKeyPad numKeyPadLeft"}
            value="7"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={
              "btn btn-success submit-button numKeyPad numKeyPadCenter"
            }
            value="8"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <LoteriaKeyPadButton
            className={"btn btn-success submit-button numKeyPad numKeyPadRight"}
            value="9"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
        </div>
        <div className="keyPadLine" style={{ paddingLeft: "5px" }}>
          <button
            className={"btn btn-danger numKeyPad numKeyPadLeft"}
            onClick={this.buttonClick}
            id={BTN_LIMPAR}
          >
            <i className={"fa fa-eraser"} style={{ marginTop: "15px" }}></i>
          </button>
          <LoteriaKeyPadButton
            className={
              "btn btn-success submit-button numKeyPad numKeyPadCenter"
            }
            value="0"
            onClick={this.handleClick.bind(this)}
          ></LoteriaKeyPadButton>
          <button
            className={"btn bg-navy numKeyPad numKeyPadRight"}
            onClick={this.buttonClick}
            id={BTN_SURPRESA}
          >
            <i className={"fa fa-gift"} style={{ marginTop: "15px" }}></i>
          </button>
        </div>
      </div>
    );
  }

  render() {
    var inputClass =
      getDeviceType() == "desktop"
        ? "col-md-12 col-sm-12 col-xs-12 nopadding"
        : "col-md-12 col-sm-12 col-xs-12 nopadding";
    const tipoJogo = this.props.modalidade.objTipoJogo;
    const maxLength =
      tipoJogo.tnyTamanhoMax +
      (tipoJogo.chrSeparador ? tipoJogo.tnyTamanhoMax - 1 : 0);
    const isNewDesign = this.props.isNewDesign;

    const isGroup = tipoJogo.tnyNumeroMax === 25 && tipoJogo.tnyNumeroMin === 1;

    // const multiplier = tipoJogo.numValorPagoJogo;

    return (
      <div
        className="col-md-12 col-sm-12 col-xs-12"
        style={{ marginTop: "10px" }}
      >
        <div className="">
          <div
            className="col-md-12 col-sm-12 col-xs-12 modalidade-input-container-title"
            style={
              this.props.orientation == "landscape"
                ? { float: "left" }
                : { padding: "0 5px 0 0" }
            }
          >
            <label
              style={{
                float: this.props.orientation == "landscape" ? "left" : "unset",
                fontSize: "15px",
                marginTop: "10px",
                paddingLeft: "0",
              }}
            >
              1. Número
            </label>
          </div>
          {isGroup ? this.renderAnimalPad() : this.renderNumericPadMobile()}
          <div className={inputClass} style={{ display: "flex" }}>
            <div
              className={`embed-submit-field div-center inputDiv ${
                isNewDesign ? "isNewDesign" : ""
              }`}
            >
              <div class="modalidade-input-holder">
                {this.props.isNewDesign ? (
                  <textarea
                    type="number"
                    class="form-control modalidade-text-input"
                    id="numeroInput"
                    inputmode="numeric"
                    pattern={`^[0-9*${tipoJogo.chrSeparador}]+$`}
                    onInput={this.handleChange}
                    value={this.props.numeroAposta}
                    maxLength={maxLength}
                  />
                ) : (
                  <input
                    type="number"
                    class="form-control modalidade-text-input"
                    id="numeroInput"
                    pattern={`^[0-9*${tipoJogo.chrSeparador}]+$`}
                    onInput={this.handleChange}
                    value={this.props.numeroAposta}
                    maxLength={maxLength}
                  />
                )}

                {/* {tipoJogo.tnyTamanhoMax !== tipoJogo.tnyTamanhoMin && ( */}
                  <button
                    class="add-number-of-input btn btn-primary submit-button"
                    onClick={() => {
                      if (this.props.numeroAposta) {
                        this.addNumber(this.props.numeroAposta);
                      }
                    }}
                    disabled={!validaNumeroDigitado(this.props.modalidade.objTipoJogo, this.props.numeroAposta)}
                  >
                    Adicionar
                  </button>
                {/* )} */}
              </div>
              <div className="numtags">
                <ul className="ks-numtags">{this.renderNumerosAposta()}</ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  numeroAposta: state.modalidadeInput.numeroAposta,
  arrNumerosAposta: state.modalidadeInput.arrNumerosAposta,
  isNewDesign: state.settings.isNewDesign,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeNumerpAposta,
      changeNumerpApostaClear,
      addNumeroAposta,
      changeNumeroApostaClearAll,
      AnalyticsSetGameStep,
      AnalyticsSetSpecifics,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModalidadeInput);



// WEBPACK FOOTER //
// ./src/loteria/modalidade/modalidadeInput.jsx